export enum QUERY_KEYS {
  changeLanguage = 'change-language',
  editFloorplanEditorSettings = 'edit-floorplan-editor-settings',
  getCompanies = 'get-companies',
  getFloorplanEditorSettings = 'user-floorplan-editor-settings',
  getUser = 'get-user',
  getUserCompanyClubs = 'user-get-company-clubs',
  removeAccount = 'remove-account',
  resetPassword = 'reset-password',
}
